import { useToasts } from "@skailer-com/uikit";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const PasswordExpiryChecker: React.FC = () => {
  const { showInfo } = useToasts();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: employeeMe } = useEmployeeMe();
  const hasShownToastRef = useRef(false);
  const toastIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (employeeMe?.is_password_expired && !hasShownToastRef.current) {
      hasShownToastRef.current = true;
      const toastId = showInfo({
        title: t("core:password_expired_title"),
        description: t("core:password_expired_description"),
        button: t("common:change_password"),
        onClick: () => {
          navigate("/account-settings");
        },
        duration: Infinity,
        showCloseButton: false,
      });
      toastIdRef.current = toastId;
    }

    if (!employeeMe?.is_password_expired && hasShownToastRef.current && toastIdRef.current) {
      toast.dismiss(toastIdRef.current);
      toastIdRef.current = null;
      hasShownToastRef.current = false;
    }
  }, [employeeMe?.is_password_expired, showInfo, t, navigate]);

  return null;
};

export default PasswordExpiryChecker;
